export const panelConstants = {
  SET_PANEL_CONFIG: 'SET_PANEL_CONFIG'
};
